import TestConnectionComponent from "./testConnectionComponent";
import { Buttons } from "./connectionSuccessful";
import React from "react";

export default function TestConnectionModule({
  onBack,
  onSubmit,
  type,
}: {
  onBack: React.Dispatch<React.SetStateAction<string>>;
  onSubmit: React.Dispatch<React.SetStateAction<string>>;
  type: string;
}) {
  return (
    <div className="mx-auto w-[379px] h-[270px] flex flex-col gap-[32px]">
      <TestConnectionComponent type={type} onSubmit={onSubmit} />
      <Buttons onBack={onBack} onSubmit={onSubmit} shouldDisable={true} />
    </div>
  );
}
